import PropTypes from 'prop-types';
import { theme } from '_constants/theme';
import { forwardRef } from 'react';
import styled from 'styled-components';

const { colors, devices, fontSizes, spaces } = theme;

const StyledBottomBannerContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: ${spaces.large24X}px;
  margin-top: ${spaces.large24X}px;
  @media ${devices.tablet} {
    margin-bottom: ${spaces.large9X}px;
    margin-top: ${spaces.large9X}px;
  }
`;
const StyledDisclaimer = styled.div`
  max-width: ${spaces.large24X * 10 + 80}px;
  width: 100%;
  text-align: center;
  margin-top: ${spaces.regular}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.regular}px;
  line-height: 150%;
  color: ${colors.gray[500]};
  @media ${devices.tablet} {
    padding-left: ${spaces.regular}px;
    padding-right: ${spaces.regular}px;
  }
`;
// eslint-disable-next-line prettier/prettier, react/display-name
const StyledBottomBannerSection = styled(
  forwardRef(({ moreSpace, imgTopDesktopPosition, ...props }, ref) => (
    <div ref={ref} {...props} />
  ))
)`
  display: flex;
  justify-content: space-between;
  background: ${colors.blue[600]};
  border-radius: 40px;
  max-width: ${spaces.large24X * 10 + 80}px;
  width: 100%;
  padding-left: ${spaces.large14X}px;
  padding-right: ${spaces.large14X}px;
  padding-top: ${spaces.large9X}px;
  padding-bottom: ${spaces.large9X}px;
  .header {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.large11X}px;
    line-height: 130%;
    color: ${colors.white};
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    margin-bottom: ${({ moreSpace }) =>
      moreSpace ? spaces.large4X : spaces.medium}px;
    margin-right: ${spaces.large14X}px;
  }
  .footer {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 400;
    font-size: ${fontSizes.large}px;
    line-height: 150%;
    color: ${colors.blue[100]};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .column1 {
    padding-right: ${spaces.regular}px;
  }
  .column2 {
    margin-top: ${({ imgTopDesktopPosition }) => imgTopDesktopPosition || 0};
    margin-bottom: -60px;
    margin-right: -55px;
  }
  @media ${devices.tablet} {
    margin-left: 0;
    margin-right: 0;
    border-radius: 0px;
    box-shadow: 0px 30px 80px rgba(0, 0, 0, 0.05);
    padding-left: ${spaces.regular}px;
    padding-right: ${spaces.regular}px;
    padding-top: ${spaces.large}px;
    padding-bottom: ${spaces.large}px;
    align-items: center;
    .header {
      font-size: ${fontSizes.large}px;
      line-height: 150%;
      margin-bottom: ${({ moreSpace }) =>
        moreSpace ? spaces.regular : spaces.smallX}px;
      margin-right: ${spaces.smallX}px;
    }
    .footer {
      font-size: ${fontSizes.regular}px;
      line-height: 24px;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
    .column2 {
      margin: 0;
      img {
        height: 120px;
      }
    }
  }
`;
const BottomBannerSection = ({
  header,
  footer,
  imgSrc,
  imgTopDesktopPosition,
  moreSpace,
  disclaimer,
}) => {
  return (
    <StyledBottomBannerContainer>
      <StyledBottomBannerSection
        imgTopDesktopPosition={imgTopDesktopPosition}
        moreSpace={moreSpace}
      >
        <div className="column1">
          <div className="header">{header}</div>
          <div className="footer">{footer}</div>
        </div>
        <div className="column2">
          <picture>
            <source srcSet={imgSrc} type="image/png" />
            <img src={imgSrc} alt="Banner image" />
          </picture>
        </div>
      </StyledBottomBannerSection>
      {disclaimer && (
        <StyledDisclaimer>
          All information submitted to Trademark Genius shall be regarded as
          strictly confidential. Trademark Genius will not reveal any
          intellectual property information to any organization other than as
          necessary for submission to the USPTO.
        </StyledDisclaimer>
      )}
    </StyledBottomBannerContainer>
  );
};

BottomBannerSection.propTypes = {
  header: PropTypes.node,
  footer: PropTypes.node,
  imgSrc: PropTypes.string,
  imgTopDesktopPosition: PropTypes.string,
  moreSpace: PropTypes.bool,
  disclaimer: PropTypes.bool,
};

export default BottomBannerSection;
